import { render, staticRenderFns } from "./MerchantFinance.vue?vue&type=template&id=520ec5ee&"
import script from "./MerchantFinance.vue?vue&type=script&lang=js&"
export * from "./MerchantFinance.vue?vue&type=script&lang=js&"
import style0 from "./MerchantFinance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports